import { render, staticRenderFns } from "./ReportFooter.vue?vue&type=template&id=6b7a4722&scoped=true&"
import script from "./ReportFooter.vue?vue&type=script&lang=ts&"
export * from "./ReportFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ReportFooter.vue?vue&type=style&index=0&id=6b7a4722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a4722",
  null
  
)

export default component.exports